import React from 'react';
import Slider from 'react-slick';

const TestimonialSectionAbout = () => {
  const testimonials = [
    {
      name: "Mr. Nikhil Joshi",
      position: "Customer",
      image: "images/testimonial/pic1.jpg",
      quote: "I recently traveled to Mahabaleshwar with AB Ghule Cabs, and the service was excellent! The driver was friendly and knowledgeable about the route, which made the trip even more enjoyable. The car was in perfect condition, and the whole experience was smooth from start to finish."

,
    },
    {
      name: "Mr. Sunil Das",
      position: "Customer",
      image: "images/testimonial/pic2.jpg",
      quote: "I’ve used AB Ghule Cabs for multiple trips, and they never disappoint! The booking process is easy, the cars are always clean, and the drivers are courteous. They make travel stress-free, and I always feel safe and comfortable. Definitely my go-to service!",
    },
    {
      name: "Mr. Vikram Kulkarni",
      position: "Customer",
      image: "images/testimonial/pic3.jpg",
      quote: "I’ve been using AB Ghule Cabs for my regular airport transfers, and their service has been consistently great. The drivers are always on time, and the cars are well-maintained. I never have to worry about missing a flight or dealing with traffic. They make traveling so much easier!",
    },
    {
      name: "Mr. Rajesh Joshi",
      position: "Customer",
      image: "images/testimonial/pic1.jpg",
      quote: "I had a great experience with AB Ghule Cabs for my corporate travel. Their professional drivers and timely service made my business trips hassle-free. The cars were always well-maintained, and I felt comfortable and secure throughout the journey. I will definitely use their services again.",
    },
    {
      name: "Mr. Rajesh Patil",
      position: "Customer",
      image: "images/testimonial/pic2.jpg",
      quote: "I recently booked a cab with AB Ghule Cabs for a business trip to Pune. The car was clean, the driver was punctual, and the overall experience was hassle-free. I’ll definitely choose them for my future travels. Excellent service!",
    },
    {
      name: "Mr. Ravi Kumar",
      position: "Customer",
      image: "images/testimonial/pic3.jpg",
      quote: "I had a wonderful experience with AB Ghule Cabs on my trip to Goa. The car was spacious, the driver was courteous, and the entire journey was smooth. Their attention to detail and reliability made my trip even more enjoyable. I will definitely book again.",
    }
  ];

  const settings = {
    dots: true,  // Display dots for navigation
    infinite: true,  // Infinite loop sliding
    speed: 500,  // Transition speed in ms
    slidesToShow: 3,  // Show 3 testimonials at once
    slidesToScroll: 1,  // Scroll one testimonial at a time
    autoplay: true,  // Enable automatic sliding
    autoplaySpeed: 3000,  // Delay between slides in ms
    responsive: [
      {
        breakpoint: 1024,  // On medium screens
        settings: {
          slidesToShow: 3,  // Show 3 testimonials on medium screens
        },
      },
      {
        breakpoint: 768,  // On small screens like tablets
        settings: {
          slidesToShow: 2,  // Show 2 testimonials on smaller screens
        },
      },
      {
        breakpoint: 480,  // On mobile screens
        settings: {
          slidesToShow: 1,  // Show 1 testimonial on mobile
        },
      },
    ],
  };

  return (
    <div className="section-full p-t150 p-b120 site-bg-dark twm-testimonial-section-wrap wow fadeInDown container" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 ">
            {/* TITLE START */}
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonial</div>
              <h2 className="twm-large-title site-text-white">What Our Customers Say</h2>
            </div>
            {/* TITLE END */}
          </div>
        </div>

        <div className="section-content container">
          {/* React Slick Carousel */}
          <Slider {...settings} className='container'>
            {testimonials.map((testimonial, index) => (
              <div className="item p-3 container" key={index}>
                <div className="twm-testimonial2 drk-view">
                  <div className="twm-testimonial-head">
                    {/* <div className="media-pic">
                      <img src={testimonial.image} alt="Image" />
                    </div> */}
                    <div className="twm-author-detail">
                      <h3 className="twm-title">{testimonial.name}</h3>
                      <div className="twm-position">{testimonial.position}</div>
                    </div>
                  </div>

                  <div className="twm-testimonial-detail">
                    <p>{testimonial.quote}</p>
                    <div className="twm-rating-wrap">
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                      <span><i className="fa fa-star"></i></span>
                    </div>
                  </div>

                  <div className="twm-quote-icon">
                    <img src="images/quote.png" alt="#" />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </div>
  );
};

export default TestimonialSectionAbout;
